import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import { $isSuccessDisable, submitDisable2FA } from './model'
import { Controller, useForm } from 'react-hook-form'
import { useUnit } from 'effector-react'

type Props = {
  clientId: string
}

const PRODUCT_OPTIONS = [
  {
    label: 'Headway',
    value: 1,
  },
  {
    label: 'Nova',
    value: 2,
  },
]

type FormData = {
  reason: string
  product: string
}

export const Edit2FAModal: React.FC<Props> = ({ clientId }) => {
  const [isVisible, setIsVisible] = useState(false)

  const isSuccessDisable = useUnit($isSuccessDisable)

  const { handleSubmit, control } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      reason: '',
      product: '',
    },
  })

  const onClose = () => {
    setIsVisible(false)
  }

  const onSubmit = (data: FormData) => {
    if (window.confirm('Are you ready?')) {
      submitDisable2FA({
        clientId,
        reason: data.reason,
        product: Number(data.product),
      })
    }
  }

  useEffect(() => {
    if (isSuccessDisable) {
      setIsVisible(false)
    }
  }, [isSuccessDisable])

  return (
    <>
      <CButton onClick={() => setIsVisible(true)}>Edit</CButton>
      <CModal visible={isVisible} onClose={onClose} size={'lg'}>
        <CModalHeader>
          <CModalTitle>Edit 2FA</CModalTitle>
        </CModalHeader>
        <CForm noValidate id="rejectForm" onSubmit={handleSubmit(onSubmit)}>
          <CModalBody>
            <CRow className="mb-3">
              <CCol sm={5}>
                <Controller
                  name="reason"
                  control={control}
                  rules={{
                    required: 'Reason required',
                    validate: (value) =>
                      (value && value?.trim().length >= 3) ||
                      'Min 3 non-space characters',
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <CFormInput
                        {...field}
                        type="text"
                        label="Reason"
                        required
                        invalid={!!error?.message}
                      />
                      {error && (
                        <CFormFeedback invalid>{error.message}</CFormFeedback>
                      )}
                    </>
                  )}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={5}>
                <Controller
                  name="product"
                  control={control}
                  rules={{
                    required: 'Product required',
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <CFormSelect {...field} label="Product">
                        <option value="">Choose product</option>
                        {PRODUCT_OPTIONS.map((item) => (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </CFormSelect>
                      {error && (
                        <CFormFeedback invalid>{error.message}</CFormFeedback>
                      )}
                    </>
                  )}
                />
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={onClose}>
              Cancel
            </CButton>
            <CButton color="primary" className="px-4" type="submit">
              Edit
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
